import { Gauge } from "lucide-react";

import { Card } from "../../../shared/card/card.tsx";
import type { UtilizationCategory, UtilizationSummary } from "../types.ts";
import styles from "./utilization-report-components.module.css";

const CARDS = [
  { category: "BELOW_50", key: "below50", label: "Utilization Below 50%", tone: "blue" },
  { category: "UPTO_80", key: "upto80", label: "Utilization 50%–80%", tone: "amber" },
  { category: "UPTO_100", key: "upto100", label: "Utilization Above 80%", tone: "green" },
] as const;

export function UtilizationSummaryCards({
  summary,
  selectedCategory,
  loading,
  onSelect,
}: {
  summary: UtilizationSummary;
  selectedCategory: UtilizationCategory | null;
  loading: boolean;
  onSelect: (category: UtilizationCategory) => void;
}) {
  return (
    <div className={styles.statsGrid}>
      {CARDS.map((item) => (
        <button
          key={item.category}
          type="button"
          className={styles.statButton}
          aria-pressed={selectedCategory === item.category}
          onClick={() => onSelect(item.category)}
          disabled={loading}
        >
          <Card
            className={`${styles.statCard} ${
              selectedCategory === item.category ? styles.activeCard : ""
            }`}
          >
            <span className={`${styles.statIcon} ${styles[item.tone]}`}>
              <Gauge size={24} aria-hidden />
            </span>
            <div>
              <p className="sub-heading-xs">{item.label}</p>
              <p className="heading-lg">{summary[item.key]}</p>
            </div>
          </Card>
        </button>
      ))}
    </div>
  );
}
